import { ready } from 'brei-project-utils';
import { contentToggles } from './modules/content-toggles';
import { globalNav } from './modules/global-navigation';
import { lityCustom } from './modules/lity-custom';
import { mastheadCarousel } from './modules/masthead-carousel';
import { overlapCarousel } from './modules/overlap-carousel';
// import { slideIndicator } from './modules/slide-indicator';
// import { swipeMenu } from './modules/swipe-menu';
import { stickyNav } from './modules/sticky-nav';
import { videoControl } from './modules/video-control';
import { videoLoader } from './modules/video-loader';

// Example of importing a custom module
// import { primaryNav } from './modules/primaryNav';

const main = {

	elem: {
	},

	init() {

		this.bindUIActions();
		contentToggles.init();
		globalNav.init();
		stickyNav.init();
		lityCustom.init();
		mastheadCarousel.init();
		overlapCarousel.init();
		// swipeMenu.init();
		// slideIndicator.init();
		videoControl.init();
		videoLoader.init();

		AOS.init({
			offset: 200,
			duration: 1000,
			easing: 'ease-out-sine',
			delay: 25,
			once: true
		});
	},

	bindUIActions() {
		globalNav.bindUIActions();
		contentToggles.bindUIActions();
		// slideIndicator.bindUIActions();
	}

};

ready(function () {
	main.init();
});